
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M50 5C25.147 5 5 25.147 5 50c0 24.854 20.147 45 45 45 24.854 0 45-20.146 45-45C95 25.147 74.854 5 50 5zM25.102 50.098c.007-15.093 11.886-27.395 26.809-28.084V49L27.778 62.069a28.027 28.027 0 01-2.676-11.971zm9.304 10.7l18.276-10.052L69.27 65.107c-11.479 9.688-27.243 8.485-34.864-4.31zm30.33-2.392L54.03 49.212l-.143-15.716c14.207-.432 19.63 17.655 10.848 24.91z"}})])
      }
    
      }
    